import React from 'react';
import { CommentEnd, CommentStart } from '../comments';
import { useConfig } from '../config-context';
import { useWidth } from '../width-context';
export function SectionItem(props) {
    const { align, children, verticalAlign } = props;
    const { width } = useWidth();
    const { renderComments } = useConfig();
    if (!renderComments) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(CommentStart, null),
        React.createElement("td", { align: align, style: {
                verticalAlign,
                width,
            } },
            React.createElement(CommentEnd, null),
            children,
            React.createElement(CommentStart, null)),
        React.createElement(CommentEnd, null)));
}
//# sourceMappingURL=section-item.js.map